import React from "react";
import ReactDOM from "react-dom";
import { GoogleOAuthProvider } from '@react-oauth/google';

import App from "./App";
import { GoogleAuthProvider } from "./contexts/auth";

ReactDOM.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId="786173811979-s8f5pkidvja99amqkrfk7glh9uuulti3.apps.googleusercontent.com">
      <GoogleAuthProvider>
        <App />
      </GoogleAuthProvider>
    </GoogleOAuthProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
